var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalenderIconGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.568,
    height: 40.486,
    viewBox: "0 0 36.568 40.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_54",
    x: 0,
    y: 0,
    width: 36.568,
    height: 40.486,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#54b9a3",
    floodOpacity: 0.549
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_55",
    x: 11.13,
    y: 19.012,
    width: 14.306,
    height: 17.444,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#54b9a3",
    floodOpacity: 0.549
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_56",
    x: 11.129,
    y: 11.784,
    width: 14.307,
    height: 17.44,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#54b9a3",
    floodOpacity: 0.549
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_57",
    x: 18.94,
    y: 11.781,
    width: 14.291,
    height: 17.442,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#54b9a3",
    floodOpacity: 0.549
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_58",
    x: 3.334,
    y: 11.784,
    width: 14.292,
    height: 17.44,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#54b9a3",
    floodOpacity: 0.549
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_59",
    x: 3.335,
    y: 19.012,
    width: 14.289,
    height: 17.443,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#54b9a3",
    floodOpacity: 0.549
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_60",
    x: 18.943,
    y: 19.012,
    width: 14.287,
    height: 17.444,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#54b9a3",
    floodOpacity: 0.549
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22",
    "data-name": "Groupe 22",
    transform: "translate(4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 0)",
    filter: "url(#Trac\\xE9_54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_54-2",
    "data-name": "Trac\\xE9 54",
    d: "M1378.765,73.563c0-.475,0-.909,0-1.342a1.662,1.662,0,0,1,1.728-1.742q.919,0,1.838,0a1.649,1.649,0,0,1,1.716,1.718c0,.443,0,.885,0,1.347h6.741c0-.43,0-.852,0-1.273a1.659,1.659,0,0,1,1.791-1.792c.593,0,1.186,0,1.779,0a1.66,1.66,0,0,1,1.712,1.7c.005.452,0,.9,0,1.387.815,0,1.6,0,2.39,0a2.67,2.67,0,0,1,1.492.408,2.566,2.566,0,0,1,1.231,2.052c.01.128.013.257.013.385q0,9.6,0,19.206a2.719,2.719,0,0,1-1.048,2.306,2.594,2.594,0,0,1-1.627.543q-1.956,0-3.913,0-9.116,0-18.231,0a2.626,2.626,0,0,1-2.683-2.1,3.954,3.954,0,0,1-.062-.825q-.005-7.9,0-15.8c0-1.126,0-2.252,0-3.378a2.649,2.649,0,0,1,2.812-2.8C1377.208,73.562,1377.967,73.563,1378.765,73.563Zm-3.705,6.243v.324q0,7.751,0,15.5a1.247,1.247,0,0,0,1.429,1.407h21.846c.99,0,1.441-.454,1.442-1.453q0-7.707,0-15.414v-.366Zm21.032-4.815a1.653,1.653,0,0,1-1.6,1.667,16.869,16.869,0,0,1-2.161,0,1.606,1.606,0,0,1-1.508-1.25c-.033-.13-.044-.266-.065-.4h-6.683a1.3,1.3,0,0,0-.029.127,1.592,1.592,0,0,1-1.534,1.521c-.747.05-1.5.009-2.25,0a1.059,1.059,0,0,1-.318-.06,1.7,1.7,0,0,1-1.206-1.6c-.874,0-1.743-.03-2.608.01a1.152,1.152,0,0,0-1.064,1.124c-.018.256-.009.514-.009.77,0,.48,0,.96,0,1.448h24.7c0-.8.03-1.576-.01-2.352a1.119,1.119,0,0,0-1.086-1C1397.811,74.971,1396.962,74.991,1396.092,74.991Zm-13.474-1.422h.007c0-.454,0-.909,0-1.363a.265.265,0,0,0-.306-.306c-.612,0-1.225,0-1.837,0a.258.258,0,0,0-.294.29q0,1.363,0,2.726c0,.2.088.311.306.309q.9-.008,1.807,0c.229,0,.318-.1.315-.324C1382.614,74.458,1382.618,74.013,1382.618,73.569Zm9.595-.017h.007c0,.444.006.889,0,1.333,0,.235.082.345.328.342q.889-.011,1.778,0c.232,0,.323-.11.324-.323q0-1.348,0-2.7a.269.269,0,0,0-.307-.308c-.6,0-1.2,0-1.807,0-.224,0-.326.093-.323.319C1392.216,72.663,1392.213,73.107,1392.213,73.552Z",
    transform: "translate(-1369.14 -70.48)",
    fill: "#54b9a3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 0)",
    filter: "url(#Trac\\xE9_55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_55-2",
    "data-name": "Trac\\xE9 55",
    d: "M1517.1,310.976c.464,0,.929-.007,1.393,0a1.16,1.16,0,0,1,1.224,1.205q.025,1.259,0,2.519a1.176,1.176,0,0,1-1.256,1.21q-1.393.009-2.786,0a1.18,1.18,0,0,1-1.24-1.227q-.021-1.245,0-2.49a1.17,1.17,0,0,1,1.243-1.218C1516.154,310.97,1516.628,310.976,1517.1,310.976Zm-1.221,1.439v2.064h2.394v-2.064Z",
    transform: "translate(-1498.8 -291.96)",
    fill: "#54b9a3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 0)",
    filter: "url(#Trac\\xE9_56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_56-2",
    "data-name": "Trac\\xE9 56",
    d: "M1517.069,219.541c.473,0,.947-.007,1.421,0a1.16,1.16,0,0,1,1.221,1.205q.025,1.257,0,2.516a1.173,1.173,0,0,1-1.249,1.212q-1.391.006-2.782,0a1.175,1.175,0,0,1-1.251-1.21q-.024-1.257,0-2.516a1.165,1.165,0,0,1,1.22-1.207C1516.122,219.534,1516.6,219.541,1517.069,219.541Zm1.2,3.5v-2.057h-2.4v2.057Z",
    transform: "translate(-1498.79 -207.75)",
    fill: "#54b9a3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 0)",
    filter: "url(#Trac\\xE9_57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_57-2",
    "data-name": "Trac\\xE9 57",
    d: "M1615.863,224.449c-.474,0-.947.005-1.421,0a1.177,1.177,0,0,1-1.2-1.2q-.014-1.273,0-2.545a1.156,1.156,0,0,1,1.178-1.186q1.465-.019,2.93,0a1.146,1.146,0,0,1,1.17,1.19q.012,1.273,0,2.545a1.166,1.166,0,0,1-1.2,1.194C1616.829,224.454,1616.346,224.449,1615.863,224.449Zm1.213-1.434v-2.057h-2.4v2.057Z",
    transform: "translate(-1589.79 -207.73)",
    fill: "#54b9a3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 0)",
    filter: "url(#Trac\\xE9_58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_58-2",
    "data-name": "Trac\\xE9 58",
    d: "M1418.454,219.544c.484,0,.967-.008,1.45,0a1.168,1.168,0,0,1,1.2,1.2q.014,1.258,0,2.516a1.179,1.179,0,0,1-1.22,1.212q-1.421.009-2.842,0a1.166,1.166,0,0,1-1.218-1.208q-.012-1.258,0-2.516a1.156,1.156,0,0,1,1.214-1.208C1417.507,219.537,1417.981,219.543,1418.454,219.544Zm1.215,1.444h-2.408v2.047h2.408Z",
    transform: "translate(-1407.98 -207.76)",
    fill: "#54b9a3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 0)",
    filter: "url(#Trac\\xE9_59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_59-2",
    "data-name": "Trac\\xE9 59",
    d: "M1418.482,310.978c.464,0,.927-.006,1.391,0a1.176,1.176,0,0,1,1.241,1.247q.008,1.214,0,2.427a1.193,1.193,0,0,1-1.265,1.261q-1.376.009-2.753,0a1.18,1.18,0,0,1-1.264-1.254q-.008-1.213,0-2.427a1.169,1.169,0,0,1,1.258-1.254C1417.554,310.973,1418.018,310.978,1418.482,310.978Zm-1.215,3.491h2.4v-2.043h-2.4Z",
    transform: "translate(-1407.99 -291.96)",
    fill: "#54b9a3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, 0)",
    filter: "url(#Trac\\xE9_60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_60-2",
    "data-name": "Trac\\xE9 60",
    d: "M1615.91,310.977c.474,0,.947-.007,1.421,0a1.16,1.16,0,0,1,1.217,1.235q.008,1.228,0,2.457a1.176,1.176,0,0,1-1.245,1.243q-1.391.01-2.782,0a1.19,1.19,0,0,1-1.254-1.271q-.005-1.2,0-2.4a1.182,1.182,0,0,1,1.252-1.267C1614.983,310.972,1615.446,310.977,1615.91,310.977Zm1.2,1.439h-2.4v2.062h2.4Z",
    transform: "translate(-1589.82 -291.96)",
    fill: "#54b9a3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIconGreen);
export default __webpack_public_path__ + "static/media/calender-icon-green.415e65869ce604558ce219ac9c2f08e7.svg";
export { ForwardRef as ReactComponent };